import "./navbar.scss";
import ToolDropdown from "../Dropdown";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

const Navbar = () => {
  const history = useHistory();
  const user = useSelector((state) => state.session.authUser);
  return (
    <div>
      <div className="home-nav-container">
        <ToolDropdown />
        <div>
          {user?.providerData[0]?.photoURL ? (
            <img
              alt="profile"
              onClick={() => {
                history.push("/settings");
              }}
              style={{
                width: "2.5rem",
                borderRadius: "50%",
              }}
              src={user?.providerData[0]?.photoURL}
            />
          ) : (
            <div
              onClick={() => {
                history.push("/settings");
              }}
              style={{
                width: "2.5rem",
                height: "2.5rem",
                borderRadius: "50%",
                backgroundColor: "#447ce9",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
